import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import type { ColumnsType } from "antd/es/table";
import Table from "antd/es/table";
import React from "react";
import { Title } from "../../components/Desc";
import ProgressIndicator from "../../components/ProgressIndicator";
import strings from "../../config/localization";
import { useGetSchedulesQuery } from "../../services/appln";

interface Schedule {
  key: string;
  bandobastName: string;
  timeslotName: string;
  timeslotStart: string;
  timeslotEnd: string;
  locationName: string;
  locationKind: number;
  locationAddress: number;
  locationLatitude: string;
  locationLongitude: string;
}

const columns: ColumnsType<Location> = [
  {
    title: strings.bandobastName,
    dataIndex: "bandobastName",
    key: "bandobastName",
  },
  {
    title: strings.timeslotName,
    dataIndex: "timeslotName",
    key: "timeslotName",
  },
  {
    title: strings.startTime,
    dataIndex: "timeslotStart",
    key: "timeslotStart",
  },
  {
    title: strings.endTime,
    dataIndex: "timeslotEnd",
    key: "timeslotEnd",
  },
  {
    title: strings.locationName,
    dataIndex: "locationName",
    key: "locationName",
  },
  {
    title: strings.kind,
    dataIndex: "locationKind",
    key: "locationKind",
  },
  {
    title: strings.address,
    dataIndex: "locationAddress",
    key: "locationAddress",
  },
];

export default function ListSchedules() {
  const schedulesQueryResponse = useGetSchedulesQuery({});

  const [schedules, setSchedules] = React.useState([]);

  React.useEffect(() => {
    if (!schedulesQueryResponse.isSuccess) {
      return;
    }

    setSchedules(
      schedulesQueryResponse.data.map((e: any) => {
        return e as Schedule;
      }),
    );
  }, [schedulesQueryResponse]);

  return (
    <div>
      <Box sx={{ height: 400, width: "100%" }}>
        {(schedulesQueryResponse.isLoading ||
          schedulesQueryResponse.isFetching) && <ProgressIndicator />}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Title text={strings.schedules} />
          </Grid>
          <Grid item xs={12}>
            <Table
              virtual
              scroll={{ y: 600 }}
              columns={columns}
              dataSource={schedules}
              pagination={false}
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
